import {FormEvent} from "react";
import {observer} from "mobx-react";
import ButtonMain from "@dropDesk/presentation/components/buttons/button_main";
import {SectionButton} from "./styled";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {ConstantsStyles} from "@dropDesk/domain/entities/constants/constants_keys";


const ButtonLogin = observer(
    ({
         handleSubmit,
         loading,
         isValidForm
     }: {
        loading: boolean
        handleSubmit: (event: FormEvent) => Promise<void>
        isValidForm: boolean
    }) => {

        const appController = useInjection(AppController);
        const colors = appController.theme.colorScheme;


        return (
            <SectionButton>
                <ButtonMain
                    height={50}
                    letterFontSize={ConstantsStyles.buttonMainFontSize}
                    widthPercentage={100}
                    disabled={loading || !isValidForm}
                    loading={loading}
                    color={colors.accent}
                    type={"submit"}
                    letter={"Entrar"}
                    onClick={handleSubmit}
                />
            </SectionButton>
        );
    });

export default ButtonLogin;
